import type { WithActiveBranchId } from '@app/api/shared';

export enum NeuralNetworkLogsEndpoints {
  GetNeuralNetworkLogs = 'Get',
}

export interface ModelNeuralNetworkLogsResult {
  Id: number;
  TimestampUtc: string;
  OrganizationId: number;
  OrganizationName: string | null;
  Provider: string | null;
  Model: string | null;
  Status: string | null;
  Request: string | null;
  Response: string | null;
  InputTokens: number | null;
  OutputTokens: number | null;
  UserId: number | null;
  EntityId: number | null;
}

export interface GetNeuralNetworkLogsParams {
  DateS?: string;
  DateE?: string;
  OrganizationId?: number;
  Provider?: string;
  Model?: string;
  Status?: string;
  UserId?: number;
  EntityId?: number;
  Search?: string;
  Skip?: number;
  Take?: number;
}

export type GetNeuralNetworkLogsRequest =
  WithActiveBranchId<GetNeuralNetworkLogsParams>;

export type GetNeuralNetworkLogsResponse = ModelNeuralNetworkLogsResult[];
